import {
  Theme,
  ComponentsProps,
  ComponentsOverrides,
  ComponentsVariants,
} from '@mui/material/styles';

const muiInput: {
  defaultProps?: ComponentsProps['MuiInput'];
  styleOverrides?: ComponentsOverrides<Theme>['MuiInput'];
  variants?: ComponentsVariants['MuiInput'];
} = {
  styleOverrides: {
    input: {
      '&::placeholder': {
        fontSize: 14,
      },
      fontSize: 14,
    },
  },
};

export default muiInput;
